"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regions = void 0;
exports.regions = [
    {
        businessUnit: 'BOT',
        regionToGetCycle: 'COSEN',
        regionToGetProducts: 'COSEN',
        states: ['AC', 'AM', 'RR', 'RO', 'AP', 'PA', 'MT', 'TO', 'DF', 'GO', 'MS', 'MG', 'ES', 'RJ'],
    },
    {
        businessUnit: 'BOT',
        regionToGetCycle: 'NE',
        regionToGetProducts: 'NE',
        states: ['MA', 'PI', 'CE', 'RN', 'PB', 'PE', 'AL', 'SE', 'BA'],
    },
    {
        businessUnit: 'BOT',
        regionToGetCycle: 'SSP',
        regionToGetProducts: 'SSP',
        states: ['SP', 'PR', 'SC', 'RS'],
    },
    {
        businessUnit: 'EUD',
        regionToGetCycle: 'RN',
        regionToGetProducts: 'Brasil',
        states: ['RN'],
    },
    {
        businessUnit: 'EUD',
        regionToGetCycle: 'CE/MG',
        regionToGetProducts: 'Brasil',
        states: ['CE', 'MG'],
    },
    {
        businessUnit: 'EUD',
        regionToGetCycle: 'SP/SPC/SE/BA/RJ',
        regionToGetProducts: 'Brasil',
        states: ['SP', 'SPC', 'SE', 'BA', 'RJ'],
    },
    {
        businessUnit: 'EUD',
        regionToGetCycle: 'SPI/PE/AL/MT/MS/ES/RS',
        regionToGetProducts: 'Brasil',
        states: ['SPI', 'PE', 'AL', 'MT', 'MS', 'ES', 'RS'],
    },
    {
        businessUnit: 'EUD',
        regionToGetCycle: 'DF/AM/PR/SC',
        regionToGetProducts: 'Brasil',
        states: ['DF', 'AM', 'PR', 'SC'],
    },
    {
        businessUnit: 'EUD',
        regionToGetCycle: 'MA/PI/PB/GO/PA',
        regionToGetProducts: 'Brasil',
        states: ['MA', 'PI', 'PB', 'GO', 'PA'],
    },
    {
        businessUnit: 'EAM',
        regionToGetCycle: 'COSEN',
        regionToGetProducts: 'COSEN',
        states: ['AC', 'AM', 'RR', 'RO', 'AP', 'PA', 'MT', 'TO', 'DF', 'GO', 'MS', 'MG', 'ES', 'RJ'],
    },
    {
        businessUnit: 'EAM',
        regionToGetCycle: 'NE',
        regionToGetProducts: 'NE',
        states: ['MA', 'PI', 'CE', 'RN', 'PB', 'PE', 'AL', 'SE', 'BA'],
    },
    {
        businessUnit: 'EAM',
        regionToGetCycle: 'SSP',
        regionToGetProducts: 'SSP',
        states: ['SP', 'PR', 'SC', 'RS'],
    },
];
